import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick", "onLongpress", "onContextmenu"]
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  key: 1,
  class: "num"
}
const _hoisted_5 = {
  key: 2,
  class: "num-notify"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "content-header" }
const _hoisted_8 = { class: "content-header-label" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "middle-box" }
const _hoisted_11 = {
  key: 0,
  class: "middle-box-at"
}
const _hoisted_12 = { class: "middle-box-content" }
const _hoisted_13 = { class: "content-footer" }
const _hoisted_14 = { class: "time" }

import { ref, onMounted, onUnmounted, watch } from '../../../adapter-vue';
import TUIChatEngine, {
  TUIStore,
  StoreName,
  TUIConversationService,
  IConversationModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, isIOS, addLongPressListener } from '@tencentcloud/universal-api';
import TUICore from '@tencentcloud/tui-core';
import Icon from '../../common/Icon.vue';
import Avatar from '../../common/Avatar/index.vue';
import ActionsMenu from '../actions-menu/index.vue';
import muteIcon from '../../../assets/icon/mute.svg';
import { isPC, isH5, isUniFrameWork, isMobile } from '../../../utils/env';
import Server from '../../TUIContact/server';
import {
  getRuntimeToAccount,
  getRuntimeUserID,
} from '@/utils/chat_runtime_params';
import { isPostMessageSenderOriginAllowed } from '@/utils/post_message_security';

interface IUserStatus {
  statusType: number;
  customStatus: string;
}

interface IUserStatusMap {
  [userID: string]: IUserStatus;
}

const LAST_CONVERSATION_ID_KEY = 'gx_chat_conversation_id';
interface conversationModel extends IConversationModel {
  // description: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['handleSwitchConversation', 'getPassingRef','saveAllConversationList'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;
const currentConversation = ref<IConversationModel>();
const currentConversationID = ref<string>();
const currentConversationDomRect = ref<DOMRect>();
const isShowOverlay = ref<boolean>(false);
const conversationList = ref<IConversationModel[]>([]);
const conversationListDomRef = ref<HTMLElement | undefined>();
const conversationListInnerDomRef = ref<HTMLElement | undefined>();
const actionsMenuPosition = ref<{
  top: number;
  left: number | undefined;
  conversationHeight: number | undefined;
}>({
  top: 0,
  left: undefined,
  conversationHeight: undefined,
});
const displayOnlineStatus = ref(false);
const userOnlineStatusMap = ref<IUserStatusMap>();

let lastestOpenActionsMenuTime: number | null = null;

const otherId = ref('')
const originToChat = ref('')
let saveAtList: any[] = []
let conversationListUpdateToken = 0
onMounted(async () => {
  otherId.value = getRuntimeToAccount() || ''
  
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
     conversationList:  onConversationListUpdated,
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.watch(StoreName.USER, {
    displayOnlineStatus: onDisplayOnlineStatusUpdated,
    userStatusList: onUserStatusListUpdated,
  });

  if (!isUniFrameWork && isIOS && !isPC) {
    addLongPressHandler();
  }
  window.addEventListener("message", handleConversationMessage);
});

onUnmounted(() => {
  conversationListUpdateToken++;
  originToChat.value = '';
  window.removeEventListener('message', handleConversationMessage)
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
    conversationList: onConversationListUpdated,
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.unwatch(StoreName.USER, {
    displayOnlineStatus: onDisplayOnlineStatusUpdated,
    userStatusList: onUserStatusListUpdated,
  });
});

const handleConversationMessage = (event: MessageEvent) => {
  if (!isPostMessageSenderOriginAllowed(event.origin)) {
    console.warn('[gx_chat] conversation postMessage: rejected sender origin', event.origin);
    return;
  }
  if (typeof event.data !== 'object' || event.data === null || Array.isArray(event.data)) {
    return;
  }
  const rawToUser = (event.data as { toUser?: unknown }).toUser;
  const toUser = typeof rawToUser === 'string' || typeof rawToUser === 'number' ? String(rawToUser) : '';
  if (toUser) {
    conversationListUpdateToken++;
    otherId.value = '';
    originToChat.value = toUser;
    void onConversationList();
  }
};

const isShowUserOnlineStatus = (conversation: IConversationModel): boolean => {
  return (
    displayOnlineStatus.value
    && conversation.type === TUIChatEngine.TYPES.CONV_C2C
  );
};

const showConversationActionMenu = (
  event: Event,
  conversation: IConversationModel,
  index: number,
  isContextMenuEvent?: boolean,
) => {
  if (isContextMenuEvent) {
    event.preventDefault();
    if (isUniFrameWork) {
      return;
    }
  }
  currentConversation.value = conversation;
  lastestOpenActionsMenuTime = Date.now();
  getActionsMenuPosition(event, index);
};

const closeConversationActionMenu = () => {
  // Prevent continuous triggering of overlay tap events
  if (
    lastestOpenActionsMenuTime
    && Date.now() - lastestOpenActionsMenuTime > 300
  ) {
    currentConversation.value = undefined;
    isShowOverlay.value = false;
  }
};

const getActionsMenuPosition = (event: Event, index: number) => {
  if (isUniFrameWork) {
    if (typeof conversationListDomRef.value === 'undefined') {
      emits('getPassingRef', conversationListDomRef);
    }
    const query = TUIGlobal?.createSelectorQuery().in(conversationListDomRef.value);
    query.select(`#convlistitem-${index}`).boundingClientRect((data) => {
      if (data) {
        actionsMenuPosition.value = {
          // The uni-page-head of uni-h5 is not considered a member of the viewport, so the height of the head is manually increased.
          top: data.bottom + (isH5 ? 44 : 0),
          // @ts-expect-error in uniapp event has touches property
          left: event.touches[0].pageX,
          conversationHeight: data.height,
        };
        isShowOverlay.value = true;
      }
    }).exec();
  } else {
    const rect = ((event.currentTarget || event.target) as HTMLElement)?.getBoundingClientRect() || {};
    if (rect) {
      actionsMenuPosition.value = {
        top: rect.bottom,
        left: isPC ? (event as MouseEvent).clientX : undefined,
        conversationHeight: rect.height,
      };
    }
    isShowOverlay.value = true;
  }
};

const enterConversationChat = (conversationID: string,conversationList:any) => {
  emits('handleSwitchConversation', conversationID,conversationList);
  void TUIConversationService.switchConversation(conversationID).catch(() => {
    console.warn('[gx_chat] Failed to switch conversation');
  });
};

function addLongPressHandler() {
  if (!conversationListInnerDomRef.value) {
    return;
  }
  addLongPressListener({
    element: conversationListInnerDomRef.value,
    onLongPress: (event, target) => {
      const index = (Array.from(conversationListInnerDomRef.value!.children) as HTMLElement[]).indexOf(target!);
      showConversationActionMenu(event, conversationList.value[index], index);
    },
    options: {
      eventDelegation: {
        subSelector: '.tui-conversation-content',
      },
    },
  });
}

function onCurrentConversationUpdated(conversation: IConversationModel) {
  currentConversation.value = conversation;
}

// 定义一个继承自IConversationModel的interface
const TUIContactServer = Server.getInstance();
const TUIConstants = TUIContactServer.constants;
const TUISearchServer = ref<any>(null);
  const needSearch = ref(false);
const generateSearchServer = (isNeedSearch: any) => {
  TUISearchServer.value = TUICore.getService(TUIConstants.TUISearch.SERVICE.NAME);
  if (TUISearchServer.value) {
    needSearch.value = isNeedSearch;
  } else {
    console.warn('请添加 TUISearch 组件');
  }
};
function setConversationList(nextList: IConversationModel[]) {
  emits('saveAllConversationList', nextList);
  conversationList.value = nextList;
}
function getLastConversationID(): string | null {
  return sessionStorage.getItem(LAST_CONVERSATION_ID_KEY);
}
function ensureSearchServer(): boolean {
  generateSearchServer(true)
  return Boolean(TUISearchServer.value?.searchUser)
}
async function searchUserProfile(userID: string): Promise<any | null> {
  if (!userID || !ensureSearchServer()) {
    return null
  }
  try {
    const imResponse: any = await TUISearchServer.value.searchUser(userID);
    return imResponse?.data?.[0] ?? null
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[gx_chat] searchUser failed')
    }
    return null
  }
}
async function getSelf(){
  const selfId = getRuntimeUserID()
  if (!selfId) {
    return null
  }
  let profile = await searchUserProfile(selfId)
  if (!profile) {
    return null
  }
  let selfObj = {
        conversationID:'C2C'+selfId,
        unreadCount:0,
        type:'C2C',
        userProfile:profile,
        lastMessage: {
          lastTime: 0,
          lastSequence: 0,
          fromAccount: "",
          messageForShow: "",
          payload: null,
          type: "",
          isRevoked: false,
          cloudCustomData: "",
          onlineOnlyFlag: false,
          nick: "",
          nameCard: "",
          version: 0,
          isPeerRead: false,
          revoker: null
        },
        peerReadTime:0,
        avatar: "//gx-img.theiabay.store/img/photo/avatar_buy.png",
        getAvatar(){
          return profile?.avatar
        },
        getShowName(){
          return `我 (${profile?.nick})`
        },
        getLastMessage(key:string){
          let aaa = {
            lastTime: 0,
            lastSequence: 0,
            fromAccount: "",
            messageForShow: "",
            payload: null,
            type: "",
            isRevoked: false,
            cloudCustomData: "",
            onlineOnlyFlag: false,
            nick: "",
            nameCard: "",
            version: 0,
            isPeerRead: false,
            revoker: null,
            text:'快来给自己发一条消息吧！'
          }
          return aaa[key]
        },
  }
  return selfObj
}
async function onConversationList(){
  const target = originToChat.value;
  if (!target) return;
  const targetID = 'C2C' + target;
  if (!conversationList.value.some(item => item.conversationID === targetID)) {
    const updateToken = conversationListUpdateToken;
    const otherConversation = await getOther(target);
    if (!otherConversation || originToChat.value !== target || updateToken !== conversationListUpdateToken) return;
    if (!conversationList.value.some(item => item.conversationID === targetID)) {
      setConversationList([...conversationList.value, otherConversation]);
    }
  }
  originToChat.value = '';
  enterConversationChat(targetID, conversationList.value);
}
async function onConversationListUpdated(list: any) {
  const updateToken = ++conversationListUpdateToken
  let flag = true
  let arr: IConversationModel[] = []
  const selfId = getRuntimeUserID()
  for(let i in list){
    list[i].avatar = list[i]?.userProfile?.avatar
    list[i].getAvatar = function (){
      return list[i].avatar
    }
    if(selfId && list[i].conversationID==='C2C'+selfId){
      list[i].getShowName=function(){
          return `我 (${list[i]?.userProfile
          .nick})`
        }
      flag = false
    }
    if(list[i]?.groupProfile?.name!='Tyche-OTC'){
      arr.push(list[i])
    }
  }
  setConversationList(arr);
  let nextList = [...arr]
  if(flag){
    let selfConversation = await getSelf()
    if (updateToken !== conversationListUpdateToken) {
      return
    }
    if (selfConversation && !nextList.some(item => item.conversationID === selfConversation.conversationID)) {
      nextList.unshift(selfConversation)
    }
  }
  const target = otherId.value || originToChat.value;
  if(target && !nextList.some(item => item.conversationID === 'C2C' + target)){
    let otherConversation = await getOther(target)
    if (updateToken !== conversationListUpdateToken) {
      return
    }
    if (otherConversation && !nextList.some(item => item.conversationID === otherConversation.conversationID)) {
      nextList.push(otherConversation)
    }
  }
  setConversationList(nextList);
  if(target && (otherId.value || originToChat.value) === target && nextList.some(item => item.conversationID === 'C2C' + target)){
    otherId.value = '';
    originToChat.value = '';
    enterConversationChat('C2C'+target, nextList);
    return;
  }
  const lastID = getLastConversationID();
  if(lastID && !currentConversationID.value && !target && nextList.some(item => item.conversationID === lastID)){
    enterConversationChat(lastID, nextList);
  }
}
async function getOther(id:any){
  let profile = await searchUserProfile(id)
  if (!profile) {
    return null
  }
  let otherObj = {
        conversationID:'C2C'+id,
        unreadCount:0,
        type:'C2C',
        userProfile:profile,
        lastMessage: {
          lastTime: 0,
          lastSequence: 0,
          fromAccount: "",
          messageForShow: "",
          payload: null,
          type: "",
          isRevoked: false,
          cloudCustomData: "",
          onlineOnlyFlag: false,
          nick: "",
          nameCard: "",
          version: 0,
          isPeerRead: false,
          revoker: null
        },
        peerReadTime:0,
        avatar: "//gx-img.theiabay.store/img/photo/avatar_buy.png",
        getAvatar(){
          return profile?.avatar
        },
        getShowName(){
          const name = profile?.nick || String(id);
          try {
            return decodeURI(name);
          } catch {
            return name;
          }
        },
        getLastMessage(key:string){
          let aaa = {
            lastTime: 0,
            lastSequence: 0,
            fromAccount: "",
            messageForShow: "",
            payload: null,
            type: "",
            isRevoked: false,
            cloudCustomData: "",
            onlineOnlyFlag: false,
            nick: "",
            nameCard: "",
            version: 0,
            isPeerRead: false,
            revoker: null,
            text:'还未有新消息'
          }
          return aaa[key]
        },
  }
  return otherObj
}
function onCurrentConversationIDUpdated(id: string) {
  currentConversationID.value = id;
}

function onDisplayOnlineStatusUpdated(status: boolean) {
  displayOnlineStatus.value = status;
}

function onUserStatusListUpdated(list: Map<string, IUserStatus>) {
  if (list.size !== 0) {
    userOnlineStatusMap.value = [...list.entries()].reduce(
      (obj, [key, value]) => {
        obj[key] = value;
        return obj;
      },
      {} as IUserStatusMap,
    );
  }
}
// Expose to the parent component and close actionsMenu when a sliding event is detected
__expose({ closeChildren: closeConversationActionMenu });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "conversationListInnerDomRef",
    ref: conversationListInnerDomRef,
    class: "tui-conversation-list"
  }, [
    (_unref(isShowOverlay))
      ? (_openBlock(), _createBlock(ActionsMenu, {
          key: 0,
          selectedConversation: _unref(currentConversation),
          actionsMenuPosition: _unref(actionsMenuPosition),
          selectedConversationDomRect: _unref(currentConversationDomRect),
          onCloseConversationActionMenu: closeConversationActionMenu
        }, null, 8, ["selectedConversation", "actionsMenuPosition", "selectedConversationDomRect"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversationList), (conversation, index) => {
      return (_openBlock(), _createElementBlock("div", {
        id: `convlistitem-${index}`,
        key: index,
        class: _normalizeClass([
        'tui-conversation-content',
        _unref(isMobile) && 'tui-conversation-content-h5 disable-select',
      ])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
          _unref(isPC) && 'isPC',
          'tui-conversation-item',
          _unref(currentConversationID) === conversation.conversationID &&
            'tui-conversation-item-selected',
          conversation.isPinned && 'tui-conversation-item-pinned',
        ]),
          onClick: ($event: any) => (enterConversationChat(conversation.conversationID,_unref(conversationList))),
          onLongpress: ($event: any) => (showConversationActionMenu($event, conversation, index)),
          onContextmenu: ($event: any) => (showConversationActionMenu($event, conversation, index, true))
        }, [
          _createElementVNode("aside", _hoisted_3, [
            _createVNode(Avatar, {
              useSkeletonAnimation: "",
              url: conversation.getAvatar(),
              size: "30px"
            }, null, 8, ["url"]),
            (_unref(userOnlineStatusMap) && isShowUserOnlineStatus(conversation))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
              'online-status',
              Object.keys(_unref(userOnlineStatusMap)).length > 0 &&
                Object.keys(_unref(userOnlineStatusMap)).includes(
                  conversation.userProfile.userID
                ) &&
                _unref(userOnlineStatusMap)[conversation.userProfile.userID]
                  .statusType === 1
                ? 'online-status-online'
                : 'online-status-offline',
            ])
                }, null, 2))
              : _createCommentVNode("", true),
            (conversation.unreadCount > 0 && !conversation.isMuted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(conversation.unreadCount > 99 ? "99+" : conversation.unreadCount), 1))
              : _createCommentVNode("", true),
            (conversation.unreadCount > 0 && conversation.isMuted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(conversation.getShowName()), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (
                  conversation.type === 'GROUP' &&
                    conversation.groupAtInfoList &&
                    conversation.groupAtInfoList.length > 0
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(conversation.getGroupAtInfo()), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_12, _toDisplayString(!conversation.getLastMessage("text")?'':conversation.getLastMessage("text")?.replaceAll('<p>','').replaceAll('</p>','').indexOf('||**||')<0?conversation.getLastMessage("text")?.replaceAll('<p>','').replaceAll('</p>',''):_unref(TUITranslateService).t('TUIChat.系统消息')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(conversation.getLastMessage("time")), 1),
              (conversation.isMuted)
                ? (_openBlock(), _createBlock(Icon, {
                    key: 0,
                    file: _unref(muteIcon)
                  }, null, 8, ["file"]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 42, _hoisted_2)
      ], 10, _hoisted_1))
    }), 128))
  ], 512))
}
}

})